import { Discount } from "../Discount/discountTypes"
import { convertTextToNumber, roundTo2Decimal } from "../utils/utils"

export function calculatePriceForProduct(
    basePrice: number | undefined,
    discount: Discount | null | undefined,
    numberOfItems: number,
    packageSize?: number
): {
    sumPrice: number
    perPiecePrice: number
} {
    const numberOfOrderUnit = packageSize
        ? numberOfItems / packageSize
        : numberOfItems

    if (!discount) {
        if (basePrice === undefined) {
            return {
                sumPrice: 0,
                perPiecePrice: 0,
            }
        }
        return {
            sumPrice: basePrice * numberOfItems,
            perPiecePrice: basePrice,
        }
    } else if (discount.type === "layered") {
        if (numberOfOrderUnit < 5) {
            return {
                sumPrice: roundTo2Decimal(
                    numberOfItems *
                        convertTextToNumber(discount.value.layerPrice[1])
                ),
                perPiecePrice: formatPriceOutput(discount.value.layerPrice[1]),
            }
        } else if (numberOfOrderUnit < 10 && discount.value.layerPrice[5]) {
            return {
                sumPrice: roundTo2Decimal(
                    numberOfItems *
                        convertTextToNumber(discount.value.layerPrice[5])
                ),
                perPiecePrice: formatPriceOutput(discount.value.layerPrice[5]),
            }
        } else if (
            numberOfOrderUnit >= 10 &&
            (discount.value.layerPrice[10] || discount.value.layerPrice[5])
        ) {
            const multiplier =
                discount.value.layerPrice[10] || discount.value.layerPrice[5]
            return {
                sumPrice: roundTo2Decimal(
                    numberOfItems * convertTextToNumber(multiplier ?? "0")
                ),
                perPiecePrice: formatPriceOutput(multiplier ?? ""),
            }
        } else {
            return {
                sumPrice: roundTo2Decimal(
                    numberOfItems *
                        convertTextToNumber(discount.value.layerPrice[1])
                ),
                perPiecePrice: formatPriceOutput(discount.value.layerPrice[1]),
            }
        }
    } else if (discount.type === "price" && discount.value !== null) {
        const numberValue = roundTo2Decimal(convertTextToNumber(discount.value))
        return {
            sumPrice: roundTo2Decimal(numberValue * numberOfItems),
            perPiecePrice: numberValue,
        }
    } else {
        if (basePrice === undefined) {
            return {
                sumPrice: 0,
                perPiecePrice: 0,
            }
        }
        return {
            sumPrice: basePrice * numberOfItems,
            perPiecePrice: basePrice,
        }
    }
}

function formatPriceOutput(price: string): number {
    return roundTo2Decimal(convertTextToNumber(price))
}
